import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { DeleteAdvanceSearchFilterModel, SaveAdvanceSearchFilterModel } from '../business-entities/save-advance-search-filter';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
@Injectable({
  providedIn: 'root'
})

export class AdvanceSearchDataService {
  constructor(private dataProvider: DataService,
    private http: HttpClient) {
  }

  SaveAdvanceSearchFilter(viewmodel: SaveAdvanceSearchFilterModel): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.SaveAdvanceSearchFilter, viewmodel).toPromise();
  }

  GetAdvanceSearchList(moduelId:number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAdvanceSearchList,moduelId).toPromise();
  }

  DeleteAdvanceSearch(viewmodel: DeleteAdvanceSearchFilterModel): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.DeleteAdvanceSearch, viewmodel).toPromise();
  }
}
